/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Center_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Center center" |
*
* @param {Position_Center_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_center_aria_label = /** @type {((inputs?: Position_Center_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Center_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au centre centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zentrum Zentrum")
	if (locale === "it") return /** @type {LocalizedString} */ ("Centro centro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Центр центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Centro centro")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("センターセンター")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केंद्र केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Centro centro")
	return /** @type {LocalizedString} */ ("Center center")
});